import React from "react";

export default class NotFoundPage extends React.Component {
    public render(): JSX.Element {
        return (
            <div className="content-wrapper">Page Not Found</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/NotFoundPage.tsx